import { createStyles, InputBase, NativeSelect, Theme, WithStyles } from "@material-ui/core";
import * as React from "react";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "./FormNativeSelect.styles";

const BootstrapInput = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "label + &": {
                marginTop: theme.spacing(3),
            },
        },
        input: {
            height: 47,
            border: "1px solid #C4C4C4",
        },
    }),
)(InputBase);


export interface IFormNativeSelectProps extends WithStyles<typeof styles> {
    label: string
    options: any,
    className?: string,
    onChange?: any,
    id?: string,
    name?: string,
    value?: any,
    error?: boolean,
    required?: boolean,
    disabled?: boolean,
    emptyCaption?: string,
}

const FormSelectPure: React.FunctionComponent<IFormNativeSelectProps> = ({
                                                                             label,
                                                                             className,
                                                                             options,
                                                                             onChange,
                                                                             id,
                                                                             name,
                                                                             value,
                                                                             required,
                                                                             disabled,
                                                                             emptyCaption,
                                                                             classes
                                                                         }: IFormNativeSelectProps) => {

    return <div className={className}>
        <NativeSelect
            placeholder={label}
            id={id ?? name}
            name={name ?? id}
            variant="outlined"
            fullWidth={true}
            value={value}
            onChange={onChange}
            required={required}
            className={classes.inputField}
            input={<BootstrapInput />}
            disabled={disabled}
        >
            {emptyCaption
                ? <option key={"empty"} value="">{emptyCaption} {required ? " *" : ""}</option>
                : null
            }
            {options?.map(c => (
                <option key={c.shortcut} value={c.name}>{c.name}</option>
            ))}
        </NativeSelect>
    </div>;
};

export const FormNativeSelect = withStyles(styles)(FormSelectPure);